<template>
  <div id="role-edit">
    <Modal v-model="modal.visible" :title="modal.title" footer-hide>

      <IForm :key="modal.visible" :model="edit" :elem="roleElem" :rules="roleRule"
             :width="520" :label-width="80" button button-text="取消" @on-submit="handleSubmit" @on-click="modal.visible = false" >

        <div slot="extend">
          <FormItem :label-width="80" label="省份" prop="provinceCode"  v-if="(userType >= 2 && userType <= 3) || (userType >= 2 && userType <= 3 && roleId == edit.parentId && edit.id) || (isAdmin && edit.level && edit.level == 3 && edit.id)">
            <Select v-model="areaController.provinceCode" style="width: 415px" :multiple="userType == 2 || isAdmin" @on-change="changeProvince" :disabled="isAdmin || (edit.id != null && edit.institutionId != null)">
              <Option v-for="item in provinceList" :value="item.code" v-bind:key="item.code"  >{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem :label-width="80" label="城市" prop="cityCode" v-if="(userType >= 3 && userType <= 4) || (userType >= 3 && userType <= 4 && roleId == edit.parentId && edit.id) || (isAdmin && edit.level && edit.level == 4 && edit.id)">
            <Select v-model="areaController.cityCode" style="width: 415px" :multiple="userType == 3 || isAdmin" @on-change="changeCity" :disabled="isAdmin || (edit.id != null && edit.institutionId != null)">
              <Option v-for="item in cityList" :value="item.code" v-bind:key="item.code"  >{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem :label-width="80" label="区" prop="areaCode" v-if="(userType >= 4 && userType <= 5) || (userType >= 4 && userType <= 5 && roleId == edit.parentId && edit.id) || (isAdmin && edit.level && edit.level == 5 && edit.id)">
            <Select v-model="areaController.areaCode" style="width: 415px" :multiple="userType == 4 || isAdmin" @on-change="changeArea" :disabled="isAdmin || (edit.id != null && edit.institutionId != null)">
              <Option v-for="item in areaList" :value="item.code" v-bind:key="item.code"  >{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem :label-width="80" label="街道"  prop="streetCode" v-if="(userType == 5) || (userType == 5 && roleId == edit.parentId && edit.id) || (isAdmin && edit.level && edit.level == 6 && edit.id)">
            <Select v-model="areaController.streetCode" style="width: 415px" @on-change="changeStreet" :disabled="isAdmin || (edit.id != null && edit.institutionId != null)">
              <Option v-for="item in streetList" :value="item.code" v-bind:key="item.code"  >{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem :label-width="80" label="机构"  prop="institutionId" v-if="(userType == 5) || (userType == 6 && institutionList.length > 1) || (userType == 6 && roleId == edit.parentId && edit.id && institutionList.length > 1) || (isAdmin && edit.level && edit.level == 7 && edit.id)">
            <Select v-model="areaController.institutionIds" style="width: 415px" :multiple="userType <= 6 || isAdmin" :disabled="isAdmin">
              <Option v-for="item in institutionList" :value="item.id" v-bind:key="item.id"  >{{ item.name + (item.subordinate&&item.subordinate.length > 0 ? "-" + item.subordinate : "") }}</Option>
            </Select>
          </FormItem>

          <FormItem :label-width="80" label="权限" prop="menuIds" :style="{'max-height': '350px', 'overflow-y': 'auto'}">
            <el-tree ref="menuTree" :data="menusData" show-checkbox node-key="id"
                     :default-checked-keys="[]" @check-change="menusCheck" :props="defaultProps">
            </el-tree>
          </FormItem>
        </div>

      </IForm>

    </Modal>
  </div>
</template>
<script>
import {_editRole, getRoleById, getAllBaseData
} from "@/services/manage/roles";
import {getStreetByArea, getAreaByCity, getCityByProvince} from "@/services/manage/tenant";
import {_findByStreetCode} from "@/services/manage/institutions";
export default {
  name: "RoleEdit",
  data() {
    return {
      provinceList:[],
      cityList:[],
      areaList:[],
      streetList:[],
      institutionList:[],
      menusData: [],
      userType : null,
      roleId : null,
      isAdmin : false,
      userInfo : null,
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      areaController:{
        provinceCode: "",
        cityCode : "",
        areaCode: "",
        streetCode: "",
        institutionId: "",
        institutionIds: []
      },
      modal: {
        title: "",
        visible: false
      },
      edit: {
        name: "",
        status: 1,
        level: 0,
        parentCode: "",
        tenantCodes: [],
        institutionId: '',
        institutionIds: [],
        menuIds: []
      },
      init: "",
      roleElem: [
        {
          label: "角色名",
          prop: "name",
          placeholder: "请输入角色名"
        },
        {
          label: "状态",
          prop: "status",
          placeholder: "选择状态",
          element: "select",
          option: [{
            label: "启用",
            value: 1
          }, {
            label: "禁用",
            value: 2
          }
          ]
        }
      ],
      roleRule: {
        name: [{
          required: true,
          message: "角色名不能为空",
          trigger: "blur"
        }
        ],
        status: [{
          required: true,
          message: "请选择状态",
          trigger: "blur",
          type:'number'
        }
        ],
      },
    };
  },
  mounted() {

    this.userType = this.$userSession.getUserType();
    this.roleId = this.$userSession.getRoleId();
    this.isAdmin = this.$userSession.getIsAdmin();
    this.userInfo = this.$userSession.getUserInfo();

    this.init = Object.assign({}, this.edit);
  },
  methods: {
    //省份选择市
    changeProvince(code, reset){
      if(!this.isAdmin && (this.userType < 3 || !code)){
        return;
      }

      if(Array.isArray(code)){
        return;
      }

      //根据省份编号查询市
      getCityByProvince({province : code}).then(res=>{
        if(res.data) {
          this.cityList = res.data;
          if(reset) {
            this.areaController.provinceCode = this.edit.parentCode;
            this.areaController.cityCode = this.edit.tenantCodes;
          }
        }else{
          this.areaController.cityCode = "";
          this.cityList = [];
        }
      }).catch(() => {
        this.areaController.cityCode = "";
        this.cityList = [];
      });
    },
    //市选择区
    changeCity(code, reset){
      if(!this.isAdmin && (this.userType < 4 || !code)){
        return;
      }

      if(Array.isArray(code)){
        return;
      }

      //根据市编号查询区
      getAreaByCity({cityCode: code}).then(res=>{
        if(res.data) {
          this.areaList = res.data;
          if(reset) {
            this.areaController.cityCode = this.edit.parentCode;
            this.areaController.areaCode = this.edit.tenantCodes;
          }
        }else{
          this.areaController.areaCode = "";
          this.areaList =[];
        }
      }).catch(() => {
        this.areaController.areaCode = "";
        this.areaList =[];
      });
    },
    //区选择街道
    changeArea(code, reset){
      if(!this.isAdmin && (this.userType < 5 || !code)){
        return;
      }

      if(Array.isArray(code)){
        return;
      }

      //根据区编号查询街道
      getStreetByArea({areaCode : code}).then(res=>{
        if(res.data){
          this.streetList = res.data;
          if(reset) {
            this.areaController.areaCode = this.edit.parentCode;
            this.areaController.streetCode = this.edit.tenantCodes[0];
          }
        }else{
          this.areaController.streetCode = "";
          this.streetList = [];
        }
      }).catch(() => {
        this.areaController.streetCode = "";
        this.streetList = [];
      });
    },
    //街道选择机构
    changeStreet(code, reset){
      if(!code){
        return;
      }

      if(Array.isArray(code)){
        return;
      }

      //根据街道编号查询机构
      let _this = this;
      _findByStreetCode({streetCode:code}).then(res=>{
        if(res.data){
          _this.institutionList = res.data;

          if(_this.institutionList && _this.institutionList.length == 1){
            _this.edit.institutionId = _this.institutionList[0].id;

            if (!_this.areaController.institutionIds.includes(_this.institutionList[0].id)) {
              _this.areaController.institutionIds.push(_this.institutionList[0].id);
            }
          }else if(reset){

            if(this.edit && this.edit.tenantCodes && this.edit.tenantCodes.length > 0){
              _this.areaController.streetCode = this.edit.tenantCodes[0];
            }

            _this.areaController.institutionId = _this.edit.institutionId;
            _this.areaController.institutionIds = _this.edit.institutionIds;

          }else if(!reset){
            if(this.edit && this.edit.tenantCodes && this.edit.tenantCodes.length > 0){
              _this.areaController.streetCode = this.edit.tenantCodes[0];
            }

            _this.areaController.institutionIds = _this.institutionList;
          }else{
            _this.areaController.institutionId = "";
            _this.institutionList = [];
          }
        }else{
          _this.areaController.institutionId = "";
          _this.areaController.institutionIds = [];
          _this.institutionList = [];
        }
      });
    },
    loadAreaData(){
      if(this.userInfo) {
        let userType = this.userType;
        switch (userType) {
          case 2:
            this.provinceList = this.$userSession.getTenants();
            this.cityList = [];
            this.areaList = [];
            this.streetList = [];
            this.institutionList = [];
            break;
          case 3:
            this.provinceList = this.$userSession.getTenants();
            if(this.provinceList && this.provinceList.length == 1){
              this.changeProvince(this.provinceList[0].code);
              this.areaController.provinceCode = this.provinceList[0].code;
            }

            this.cityList = [];
            this.areaList = [];
            this.streetList = [];
            this.institutionList = [];
            break;
          case 4:
            this.provinceList = [];
            this.cityList = this.$userSession.getTenants();
            if(this.cityList && this.cityList.length == 1){
              this.changeCity(this.cityList[0].code);
              this.areaController.cityCode = this.cityList[0].code;
            }

            this.areaList = [];
            this.streetList = [];
            this.institutionList = [];
            break;
          case 5:
            this.provinceList = [];
            this.cityList = [];
            this.areaList = this.$userSession.getTenants();
            if(this.areaList && this.areaList.length == 1){
              this.changeArea(this.areaList[0].code);
              this.areaController.areaCode = this.areaList[0].code;
            }

            this.streetList = [];
            this.institutionList = [];
            break;
          case 6:
            this.provinceList = [];
            this.cityList = [];
            this.areaList = [];
            this.streetList = [];
            this.institutionList = this.$userSession.getInstitutions() ? this.$userSession.getInstitutions() : [];
            if(this.institutionList && this.institutionList.length == 1){
              this.edit.institutionIds = this.institutionList[0].id;
            }
            break;
        }
      }
    },
    /**
     * 获取菜单
     */
    handleAllMenus(res){
      this.menusData = res.data.menuNames;
      let tempKeys = []
      let count = 1;
      this.menusData.forEach(item =>{
        item.id = parseInt(item.id);
        item.label= item.name ;
        tempKeys.push(count);
        if (item.children && item.children.length > 0){
          if (item.navs){
            item.children = [...item.children,...item.navs]
          }
          item.children.forEach(subItem =>{
            subItem.id = parseInt(subItem.id);
            subItem.label = subItem.name;
            if (subItem.children && subItem.children.length >0){
              if (subItem.navs){
                subItem.children = [...subItem.children,...subItem.navs]
              }
              subItem.children.forEach(second => {
                second.id = parseInt(second.id);
                second.label = second.name;
                if (second.children && second.children.length >0) {
                  if (second.navs) {
                    second.children = [...second.children, ...second.navs]
                  }
                  second.children.forEach(three => {
                    three.id = parseInt(three.id);
                    three.label = three.name;
                    if (three.children && three.children.length >0) {
                      if (three.navs) {
                        three.children = [...three.children, ...three.navs]
                      }
                    }
                  })
                }
              })
            }
          })
        }
        count ++;
      })
      this.defaultProps.expandedKeys = tempKeys;
    },
    /**
     * 选中树节点
     * @param data
     * @param nodeSelected 是否被选中
     */
    menusCheck(data,nodeSelected){
      this.$nextTick(()=>{
        let temp = [];
        this.$refs['menuTree'].getHalfCheckedKeys().forEach(item=>{
          temp.push(item)
        })
        this.$refs['menuTree'].getCheckedNodes().forEach(item=>{
          temp.push(item.id)
        })
        this.edit.menuIds = temp;
      })
    },
    /**
     * 显示模态框
     * @param  {string} title 模态框标题名称
     * @param  {object} row 当前行数据
     */
    handleModal(isCreate,title, row) {
      this.modal = {
        title: title,
        visible: true
      };
      getAllBaseData().then(res =>{
        this.areaController.provinceCode = [];
        this.areaController.cityCode = [];
        this.areaController.areaCode = [];
        this.areaController.streetCode = [];
        this.areaController.institutionIds = [];

        this.handleAllMenus(res);
        if (isCreate) {
          this.loadAreaData();
          this.handleCreate(); // 创建
        } else {
          this.loadAreaData();
          this.handleEdit(row); // 编辑
        }
      })
    },
    handleCreate() {
      this.edit = Object.assign({}, this.init);
    },
    handleEdit(row) {
      const params = {id: row.id};

      if(this.userType > 3){
        this.provinceList = [];
      }
      if(this.userType > 4){
        this.cityList = [];
      }
      if(this.userType > 5){
        this.areaList = [];
      }
      if(this.userType > 6){
        this.streetList = [];
      }
      // this.institutionList = [];
      this.areaController.institutionIds = [];
      this.edit.institutionIds = [];
      getRoleById(params).then(res =>{
        row = res.data;
        const edit = Object.assign({}, row);
        this.edit = {
          ...edit,
          row
        };
        this.areaController.institutionIds = this.edit.institutionIds;

        this.$nextTick(()=>{
          let arr = []
          this.edit.menuIds.forEach(item => {
            if (!this.$refs['menuTree'].getNode(item) || !this.$refs['menuTree'].getNode(item).childNodes.length) {
              arr.push(item)
            }
          })

          this.$refs['menuTree'].setCheckedKeys(arr)
          this.$forceUpdate();
        })

        if (this.userType == 2 || (this.isAdmin && this.edit.level == 3)) {
          this.areaController.provinceCode = this.edit.tenantCodes;
          if (this.isAdmin) {
            this.provinceList = this.$userSession.getTenants();
          }
        }

        if (this.userType == 3 || (this.isAdmin && this.edit.level == 4)) {
          this.changeProvince(this.edit.parentCode, true);
        }

        if (this.userType == 4 || (this.isAdmin && this.edit.level == 5)) {
          this.changeCity(this.edit.parentCode, true);
        }

        if (this.userType == 5 || (this.isAdmin && this.edit.level == 6)) {
          this.changeArea(this.edit.parentCode, true);
          if (!this.isAdmin) {
            this.changeStreet(this.edit.tenantCodes[0], true);
          }
        }

        if ((this.isAdmin && this.edit.level == 7)) {
          if (!this.isAdmin) {
            this.changeStreet(this.edit.tenantCodes[0], true);
          }
        }

        if ((this.isAdmin && this.edit.level == 7)) {
          this.changeStreet(this.edit.tenantCodes[0], true);
        }
      })
    },
    // 表单提交
    handleSubmit() {

      if(!this.edit.name || !this.edit.status){
        return;
      }

      if(this.userType == 1) {
        this.edit.tenantCodes = ""
      }else if(this.userType == 2){
        this.edit.tenantCodes = this.areaController.provinceCode;
      }else if(this.userType == 3){
        this.edit.parentCode = this.areaController.provinceCode;
        this.edit.tenantCodes = this.areaController.cityCode;
      }else if(this.userType == 4){
        this.edit.parentCode = this.areaController.cityCode;
        this.edit.tenantCodes = this.areaController.areaCode;
      }else if(this.userType == 5){
        this.edit.tenantCodes = [];
        this.edit.parentCode = this.areaController.areaCode;
        this.edit.tenantCodes.push(this.areaController.streetCode);
        this.edit.institutionIds = [...new Set(this.areaController.institutionIds)];
      }else if(this.userType >= 6){
        this.edit.parentCode = this.$userSession.getTenants()[0];
        this.edit.tenantCodes = [];
        this.edit.institutionIds = [...new Set(this.areaController.institutionIds)];
      }

      if((this.userType > 1 && this.userType < 6) && !this.id && (!this.edit.tenantCodes || this.edit.tenantCodes.length == 0)){
        this.$message.warning('请先选择地区');
        return;
      }

      if(this.userType == 5 && !this.edit.institutionId && !this.edit.institutionIds && this.edit.institutionIds.length == 0){
        return;
      }

      if(this.userType == 5 && (!this.edit.institutionIds || this.edit.institutionIds.length == 0)){
        this.$message.warning('请先选择机构');
        return;
      }
      if(this.userType == 6 && this.institutionList.length > 1 && (!this.edit.institutionIds || this.edit.institutionIds.length == 0)){
        this.$message.warning('请先选择机构');
        return;
      }

      if(this.userType == 6 && (!this.userInfo.institutions || this.userInfo.institutions.length == 0)){
        this.$message.warning('没有关联不能创建');
        return;
      }

      if(!this.edit.menuIds || this.edit.menuIds.length == 0){
        this.$message.warning('请先选择权限');
        return;
      }

      _editRole(this.edit).then(res => {
        if (res.errcode == 1){
          this.$message.success(res.errmsg);
          this.$emit("on-update");
          this.modal.visible = false;
        } else{
          this.$message.error(res.errmsg);
        }
      }).catch(() => {});
    }
  }
};
</script>
<style lang="postcss" scoped>

</style>
